import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const FreeShipping: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--free-shipping')}
    viewBox="0 0 42 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-422.000000, -2704.000000)">
        <g transform="translate(413.000000, 2688.000000)">
          <g fill="#000000" fillRule="nonzero">
            <g transform="translate(9.000000, 16.000000)">
              <path d="M41.3664216,14.16 L36.9796569,7.6875 L31.1845098,7.6875 L31.1845098,0.45 L8.07318627,0.45 L8.07318627,6 L9.22759804,6 L9.22759804,1.575 L30.030098,1.575 L30.030098,23.1675 L19.5172549,23.1675 C18.9631373,22.125 17.862598,21.405 16.5773529,21.405 C15.2921078,21.405 14.1915686,22.125 13.637451,23.1675 L9.22759804,23.1675 L9.22759804,18.9975 L8.07318627,18.9975 L8.07318627,24.2925 L13.2911275,24.2925 C13.2757353,24.405 13.2526471,24.525 13.2526471,24.6375 C13.2526471,26.4225 14.7456863,27.87 16.5773529,27.87 C18.4090196,27.87 19.9020588,26.415 19.9020588,24.6375 C19.9020588,24.5175 19.8789706,24.405 19.8635784,24.2925 L30.5996078,24.2925 L31.1845098,24.2925 L32.1080392,24.2925 C32.0926471,24.405 32.0695588,24.525 32.0695588,24.6375 C32.0695588,26.4225 33.562598,27.87 35.3942647,27.87 C37.2259314,27.87 38.7189706,26.415 38.7189706,24.6375 C38.7189706,24.5175 38.6958824,24.405 38.6804902,24.2925 L41.3664216,24.2925 L41.3664216,14.16 Z M16.5696569,26.7525 C15.3767647,26.7525 14.3993627,25.8075 14.3993627,24.645 C14.3993627,23.4825 15.3690686,22.53 16.5696569,22.53 C17.7702451,22.53 18.739951,23.475 18.739951,24.645 C18.739951,25.8075 17.7702451,26.7525 16.5696569,26.7525 Z M36.3562745,8.8125 L39.7733333,13.8525 L31.1845098,13.8525 L31.1845098,8.8125 L36.3562745,8.8125 Z M35.3942647,26.7525 C34.2013725,26.7525 33.2239706,25.8075 33.2239706,24.645 C33.2239706,23.4825 34.1936765,22.53 35.3942647,22.53 C36.5948529,22.53 37.5645588,23.475 37.5645588,24.645 C37.5568627,25.8075 36.5871569,26.7525 35.3942647,26.7525 Z M38.3341667,23.1675 C37.780049,22.125 36.6795098,21.405 35.3942647,21.405 C34.1090196,21.405 33.0084804,22.125 32.4543627,23.1675 L31.1845098,23.1675 L31.1845098,14.9775 L40.2120098,14.9775 L40.2120098,23.1675 L38.3341667,23.1675 Z" />
              <rect
                x="1.90093137"
                y="11.9325"
                width="8.87357843"
                height="1.125"
              />
              <rect
                x="3.80186275"
                y="15.6375"
                width="8.87357843"
                height="1.125"
              />
              <rect x="0" y="8.2275" width="8.87357843" height="1.125" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default FreeShipping;
